// The "we're working on it" screen shared by every tab while an
// investigation-wide pass runs (first brief, brief regeneration, re-analysis).
// Same shape everywhere so the wait reads as one thing happening.
const AnalyzingState: React.FC<{ title: string; body: string; compact?: boolean }> = ({ title, body, compact }) => {
  if (compact) {
    return (
      <div className="mb-4 flex items-center gap-3 rounded-xl border border-base-300 bg-base-100 px-4 py-3">
        <div className="size-5 shrink-0 border-[3px] border-base-300 border-t-blue-500 rounded-full animate-spin" />
        <div className="min-w-0">
          <p className="text-sm font-semibold text-base-content">{title}</p>
          <p className="text-xs text-base-content/60">{body}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="flex items-center justify-center py-24">
      <div className="text-center max-w-md mx-auto p-8">
        <div className="w-10 h-10 border-4 border-base-300 border-t-blue-500 rounded-full animate-spin mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-base-content mb-2">{title}</h3>
        <p className="text-sm text-base-content/60 mb-4">{body}</p>
        <div className="bg-green-50 dark:bg-green-950/40 border border-green-200 dark:border-green-900 rounded-lg p-3">
          <p className="text-xs text-green-800 dark:text-green-400 font-medium">You can safely leave this page. Results will be here when it's done.</p>
        </div>
      </div>
    </div>
  );
};

export default AnalyzingState;
